import React from 'react';
import './Input.css';

interface InputBoxProps {
  id?: string;
  type?: 'number' | 'text' | 'search' | 'toggle' | 'password' | 'email' | 'date' | 'checkbox' | 'radio' | 'input';
  value?: string;
  placeholder?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  className?: string;
  disabled?: boolean;
  role?: string;
  name?: string;
  checked?: boolean;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  readOnly?: boolean;
  onClick?: () => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

const InputBox: React.FC<InputBoxProps> = ({
  id = '',
  type = 'text',
  value,
  placeholder = '',
  onChange,
  label = '',
  className = '',
  disabled = false,
  role = '',
  name = '',
  checked = false,
  onFocus,
  readOnly = false,
  onClick,
  onKeyDown, // Destructure onKeyDown
}) => {
  return type === "search" ? (
    <div className="search-container">
        <i className={`fa-solid fa-magnifying-glass search-icon text-extra-light-purple searchStyle`} onClick={onClick}></i>
      <input
        id={id}
        type={"input"}
        value={value}
        placeholder={placeholder}
        aria-label={label}
        onChange={onChange}
        disabled={disabled}
        className={className}
        role={role}
        name={name}
        checked={checked}
        onFocus={onFocus}
        readOnly={readOnly}
        onKeyDown={onKeyDown}
      />
    </div>
  ) : type === "toggle" ? (
    <label className="input-switch">
      <input
        type="checkbox"
        id={id}
        value={value}
        placeholder={placeholder}
        aria-label={label}
        onChange={onChange}
        disabled={disabled}
        className={className}
        role={role}
        name={name}
        checked={checked}
        onFocus={onFocus}
        readOnly={readOnly} />
      <span className={className}></span>
    </label>
  ) : (
    <input
      id={id}
      type={type}
      value={value}
      placeholder={placeholder}
      aria-label={label}
      onChange={onChange}
      disabled={disabled}
      className={className}
      role={role}
      name={name}
      checked={checked}
      onFocus={onFocus}
      readOnly={readOnly}
      onKeyDown={onKeyDown}
    />
  );
};

export default InputBox;
